import type { CustomElement } from "./utils";
import type { ExtendToggles } from "./extend";

interface Initializable {
  /**
 *
 *
 */
  __connect: () => void;
}

/**
 *
 *
 *
 */
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      /*                                             */
      const target = entry.target as HTMLElement & Partial<Initializable>;
      if (typeof target.__connect !== "function") {
        return;
      }

      /*                                           */
      if (entry.isIntersecting) {
        /*                                       */
        /*                                                        */
        target.__connect();
      }
    });
  },
  { threshold: 0.0, rootMargin: "100px" },
);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const extendElementWithVisibilityInit = (
  Base: CustomElement,
  toggles: ExtendToggles,
): CustomElement =>
  class extends Base implements Initializable {
    wasConnected = false;

    /**
 *
 *
 *
 */
    __connect(attachShadow?: true): void {
      /*                                                                         */
      /*                                                                  */
      if (this.isConnected === false || this.wasConnected) return;

      /*                                                            */
      delete this.dataset.ocInit;

      /*                                                     */
      /*                                         */
      /*                                                                    */
      /*                                                                   */
      /*                                                                                          */
      if (!toggles[3] && !attachShadow) {
        const unset = otto.components.__onAttachShadow.sub(({ selector } = {}) => {
          if (selector && !this.matches(selector)) return;
          this.__connect(true);
          unset();
        });
        return;
      }

      super.connectedCallback();
      this.wasConnected = true;
    }

    connectedCallback(): void {
      /*                                                                           */
      if (this.wasConnected) return;

      /*                                     */
      /*                                                  */
      this.dataset.ocInit = "pending";

      /*                                          */
      /*                                               */
      observer.observe(this);
    }

    disconnectedCallback(): void {
      /*                                                                */
      if (!this.wasConnected) return;

      /*                                                                         */
      observer.unobserve(this);

      /*                                                                       */
      /*                                                                                             */
      super.disconnectedCallback();
      this.wasConnected = false;
    }
  };
